<template>
  <div class="onhover-dropdown logout-nav">
    <div class="profile-nav d-flex align-items-center">
      <div class="user-icon-wrapper">
        <vue-feather type="user" size="18" stroke-width="2.5" />
      </div>
    </div>
    <ul class="profile-dropdown onhover-show-div">
      <li>
        <a href="#" @click.prevent>
          <vue-feather type="user" size="16" />
          <span>Account</span>
        </a>
      </li>
      <li>
        <a href="#" @click.prevent>
          <vue-feather type="mail" size="16" />
          <span>Inbox</span>
        </a>
      </li>
      <li>
        <a href="#" @click.prevent>
          <vue-feather type="settings" size="16" />
          <span>Settings</span>
        </a>
      </li>
      <li>
        <a href="#" @click.prevent="logout">
          <vue-feather type="log-out" size="16" />
          <span>Log Out</span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import { clearSession } from '@/services/session';

export default {
  name: 'LogoutView',
  methods: {
    logout() {
      clearSession();
      this.$router.push('/auth/login');
    },
  },
};
</script>
